import ListItemIcon from '@components/v2/ui/List/ListItemIcon';
import ListItemText from '@components/v2/ui/List/ListItemText';
import Menu from '@components/v2/ui/Menu/Menu';
import MenuItem from '@components/v2/ui/Menu/MenuItem';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { getAnchoredPaperSpacing } from '@components/v2/ui/utils/anchoredPaperSpacing';
import { useTranslation } from '../../../../../../../../../translation/TranslationContext';
import useOrderProductGridMenuStyles from '../styles/useOrderProductGridMenu.styles';
import { OrderProductGridMenuOption } from '../types/OrderProductGrid.types';

interface OrderProductGridMenuProps {
  options: OrderProductGridMenuOption[];
  onClose: () => void;
  anchorEl: HTMLButtonElement | null;
}

const OrderProductGridMenu = ({ anchorEl, onClose, options }: OrderProductGridMenuProps) => {
  const { classes } = useOrderProductGridMenuStyles();
  const { translate } = useTranslation();

  return (
    <Menu
      elevation={0}
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      slotProps={{
        paper: { sx: getAnchoredPaperSpacing({ variant: 'dropdown', horizontal: 'left' }) },
      }}
    >
      {options
        .filter((option) => option.active)
        .map((option) => (
          <Tooltip
            key={option.label}
            TooltipContent={
              option.disabled && option.disabledMessage
                ? translate(option.disabledMessage)
                : undefined
            }
          >
            <MenuItem
              disabled={option.disabled}
              className={classes.menuItem}
              testId={option.testId}
              onMouseEnter={option.onHover}
              onMouseLeave={option.onHover}
              onClick={() => {
                option.onClick();
                onClose();
              }}
            >
              <div className={classes.menuItemContent}>
                <ListItemIcon>{option.icon}</ListItemIcon>
                <ListItemText primary={translate(option.label)} />
              </div>
            </MenuItem>
          </Tooltip>
        ))}
    </Menu>
  );
};

export default OrderProductGridMenu;
